var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { TableRow } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import { EditCell } from "./EditCell";
import Button from "@mui/material/Button";
import { makeStyles } from "tss-react/mui";
import { useAsyncAction } from "nate-react-api-helpers";
import { showSnack } from "../../TSnackbar";
import moment from "moment";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ actionWrapper: { display: "flex", alignItems: "center", justifyContent: "center" }, actionButton: { padding: 0 } }); });
export function InsertRow(props) {
    var _this = this;
    var _a = useState(), row = _a[0], setRow = _a[1];
    var defaultRow = useRef(undefined);
    var insert = useAsyncAction(function (row) { return __awaiter(_this, void 0, void 0, function () {
        var boolKeys, _i, boolKeys_1, key, dateKeys, _a, dateKeys_1, key, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    boolKeys = props.columns.filter(function (c) { return c.type === "bool" && c.key; }).map(function (c) { return c.key; });
                    for (_i = 0, boolKeys_1 = boolKeys; _i < boolKeys_1.length; _i++) { // @ts-ignore
                        key = boolKeys_1[_i];
                        if (row[key] === "") { // @ts-ignore
                            row[key] = false;
                        }
                    } // set dates to today if not already set
                    dateKeys = props.columns.filter(function (c) { return c.type === "date" && c.key; }).map(function (c) { return c.key; });
                    for (_a = 0, dateKeys_1 = dateKeys; _a < dateKeys_1.length; _a++) { // @ts-ignore
                        key = dateKeys_1[_a];
                        if (row[key] === "") { // @ts-ignore
                            row[key] = moment().startOf("day");
                        }
                    }
                    return [4 /*yield*/, props.insert(row)];
                case 1:
                    _b.sent();
                    setRow(defaultRow.current);
                    showSnack("Row added!", { variant: "success" });
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    showSnack(e_1.message, { variant: "error" });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [props.insert]);
    useEffect(function () {
        var row = props.columns.reduce(function (acc, col) {
            if (!col.key)
                return acc;
            switch (col.type) {
                case "date":
                case "date-time":
                case "time": // @ts-ignore
                    acc[col.key] = "";
                    return acc;
                case "money": // @ts-ignore
                    acc[col.key] = 0;
                    return acc;
                case "number": // @ts-ignore
                    acc[col.key] = 0;
                    return acc;
                default: // @ts-ignore
                    acc[col.key] = "";
                    return acc;
            }
        }, {});
        setRow(row);
        defaultRow.current = row;
    }, [props.columns]);
    var styles = useStyles().classes;
    if (!row)
        return null;
    return /*#__PURE__*/ _jsxs(TableRow, { children: [/*#__PURE__*/ _jsx(TableCell, { padding: "checkbox", children: /*#__PURE__*/ _jsx(Checkbox, { checked: false, disabled: true }) }, "checkbox"), props.columns.slice(0, props.columns.length - 1).map(function (c, index) { /*#__PURE__*/ return _jsx(EditCell, { row: row, onChange: setRow, value: valueSelector(c, row), column: c, index: index, rowId: "insert" }, c.name); }), /*#__PURE__*/ _jsx(TableCell, { style: actionStyle, children: row !== defaultRow.current && /*#__PURE__*/ _jsxs("div", { className: styles.actionWrapper, children: [/*#__PURE__*/ _jsx(Button, { className: styles.actionButton, size: "small", variant: "contained", disableElevation: true, color: "primary", onClick: function () { return insert.callback(row); }, children: "Add" }), /*#__PURE__*/ _jsx("div", { style: { width: 8 } }), /*#__PURE__*/ _jsx(Button, { className: styles.actionButton, onClick: function () { return setRow(defaultRow.current); }, size: "small", variant: "contained", disableElevation: true, children: "Cancel" })] }) }, "actions")] });
}
function valueSelector(c, row) { if (!c.key) {
    if (c.type === "computed")
        return c.selector(row);
    return "";
} var v = row[c.key]; if (v === undefined)
    return ""; return v; }
export var actionStyle = { width: 150, padding: "0 12px 0 16px" };
